module.exports = __webpack_public_path__ + "static/media/nightowls.7a722c1a.jpg";